import { Link } from 'react-router-dom';
import { Clock, Eye } from 'lucide-react';
const BACKEND = process.env.REACT_APP_BACKEND_URL;

const fixImg = (url) => !url ? null : (url.startsWith('http') ? url : `${BACKEND}${url}`);
const fmtDate = (iso) => iso ? new Date(iso).toLocaleDateString('hr') : '';

/**
 * FEATURED — large lead on left, 3 secondary stacked on right with thumbnails.
 */
export default function FeaturedBlock({ category, articles }) {
  if (!articles?.length) return null;
  const color = category?.color || '#dc2626';
  const [lead, ...rest] = articles.slice(0, 4);
  return (
    <div className="grid md:grid-cols-2 gap-6" data-testid="featured-block">
      <Link to={`/clanak/${lead.slug}`} className="group block" data-testid="featured-lead">
        <div className="aspect-[16/10] rounded-xl overflow-hidden bg-gray-100 dark:deep-black-card">
          {fixImg(lead.cover_image_url) && (
            <img src={fixImg(lead.cover_image_url)} alt={lead.title_hr}
                 loading="lazy"
                 className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          )}
        </div>
        <div className="mt-3.5">
          <span className="inline-block text-white text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-sm mb-2"
                style={{ backgroundColor: color }}>{category.name_hr}</span>
          <h3 className="text-2xl font-black leading-[1.12] text-gray-900 dark:text-gray-50 group-hover:text-red-600 dark:group-hover:text-red-400 transition-colors">
            {lead.title_hr}
          </h3>
          {lead.excerpt_hr && (
            <p className="mt-2 text-[15px] text-gray-600 dark:text-gray-400 line-clamp-3 leading-relaxed">{lead.excerpt_hr}</p>
          )}
          <div className="mt-3 flex items-center gap-3 text-[11px] text-gray-400 dark:text-gray-500 uppercase tracking-wide">
            {lead.publish_at && <span className="flex items-center gap-1"><Clock size={11} />{fmtDate(lead.publish_at)}</span>}
            {typeof lead.views === 'number' && <span className="flex items-center gap-1"><Eye size={11} />{lead.views}</span>}
          </div>
        </div>
      </Link>
      <div className="space-y-4 self-stretch">
        {rest.map((a, i) => (
          <Link key={a.id} to={`/clanak/${a.slug}`} data-testid={`featured-sec-${i}`}
                className="group grid grid-cols-[112px,1fr] gap-4 items-start">
            <div className="w-28 h-20 rounded-lg overflow-hidden bg-gray-100 dark:deep-black-card shrink-0">
              {fixImg(a.cover_image_url) && (
                <img src={fixImg(a.cover_image_url)} alt={a.title_hr} loading="lazy"
                     className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              )}
            </div>
            <div>
              <h4 className="text-[15px] font-bold leading-tight text-gray-900 dark:text-gray-100 group-hover:text-red-600 dark:group-hover:text-red-400 line-clamp-3 transition-colors">
                {a.title_hr}
              </h4>
              <p className="mt-2 text-[10px] text-gray-500 dark:text-gray-500 uppercase tracking-wide">{fmtDate(a.publish_at)}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
